// extracted by mini-css-extract-plugin
export default {"container":"inicio_container__h-KDc"};